var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5776 1.63281C6.7792 1.63281 2.07764 6.33438 2.07764 12.1328C2.07764 17.9312 6.7792 22.6328 12.5776 22.6328C18.3761 22.6328 23.0776 17.9312 23.0776 12.1328C23.0776 6.33438 18.3761 1.63281 12.5776 1.63281ZM17.1128 8.70391L12.1769 15.5477C12.1079 15.6439 12.0169 15.7224 11.9116 15.7765C11.8062 15.8307 11.6894 15.8589 11.571 15.8589C11.4525 15.8589 11.3358 15.8307 11.2304 15.7765C11.1251 15.7224 11.0341 15.6439 10.9651 15.5477L8.04248 11.4977C7.95342 11.3734 8.04248 11.2 8.19482 11.2H9.29404C9.53311 11.2 9.76045 11.3148 9.90107 11.5117L11.5698 13.8273L15.2542 8.71797C15.3948 8.52344 15.6198 8.40625 15.8612 8.40625H16.9604C17.1128 8.40625 17.2019 8.57969 17.1128 8.70391Z",
    fill: "#20A76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFilled);
export default __webpack_public_path__ + "static/media/checkCircleFilled.ded0aa034607c60122211f5cd30299fe.svg";
export { ForwardRef as ReactComponent };